import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './PedidosModal.css';
import AdminIcon from './AdminIcon';
import PagamentoDetalhes, { FormasResumo, moeda } from './PagamentoDetalhes';

export default function PedidosModal({ pedidos, onClose }) {
  const dialog = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  const [abertos, setAbertos] = useState(() => new Set());

  useEffect(() => {
    const previousFocus = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current?.focus();
    const onKeyDown = event => {
      if (event.key === 'Escape') close.current();
      if (event.key === 'Tab') {
        const buttons = dialog.current.querySelectorAll('button, [tabindex="0"]');
        const first = buttons[0];
        const last = buttons[buttons.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog.current)) {
          event.preventDefault(); first.focus();
        }
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = overflow;
      document.removeEventListener('keydown', onKeyDown);
      previousFocus?.focus();
    };
  }, []);

  const alternar = id => setAbertos(atuais => {
    const proximos = new Set(atuais);
    if (!proximos.delete(id)) proximos.add(id);
    return proximos;
  });

  return createPortal(
    <div className="orders-preview-overlay" onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
      <section className="orders-preview" role="dialog" aria-modal="true" aria-labelledby="orders-preview-title" tabIndex={-1} ref={dialog}>
        <header className="orders-preview-header">
          <div className="orders-preview-icon" aria-hidden="true">▤</div>
          <div><span className="orders-preview-eyebrow">PEDIDOS RECEBIDOS</span><h3 id="orders-preview-title">Visualização de pedidos</h3><p>Confira os clientes, os valores e como cada pedido foi pago.</p></div>
          <button className="orders-preview-close" type="button" aria-label="Fechar visualização de pedidos" onClick={onClose}>×</button>
        </header>
        <div className="orders-preview-summary">
          <div><span>Total de pedidos</span><strong>{pedidos.length}</strong></div>
          <div><span>Valor total</span><strong>{moeda.format(pedidos.reduce((sum, pedido) => sum + pedido.total, 0))}</strong></div>
          <div><span>Total pago</span><strong>{moeda.format(pedidos.reduce((sum, pedido) => sum + pedido.total_pago, 0))}</strong></div>
        </div>
        <div className="orders-preview-scroll" tabIndex={0} role="region" aria-label="Lista de pedidos">
          <table className="orders-preview-table">
            <thead><tr><th aria-label="Detalhes do pagamento" /><th>Nº pedido</th><th>Cód. cliente</th><th>Cliente</th><th>Data e hora</th><th>Pagamento</th><th>Valor total</th></tr></thead>
            <tbody>{pedidos.length ? pedidos.map((pedido, index) => {
              const aberto = abertos.has(pedido.id);
              return <React.Fragment key={pedido.id}>
                <tr className={`orders-preview-row ${index % 2 ? 'is-alt' : ''} ${aberto ? 'is-open' : ''}`} onClick={() => alternar(pedido.id)}>
                  <td className="orders-preview-toggle-cell">
                    <button type="button" className="pay-toggle" aria-expanded={aberto} aria-controls={`pedido-pagamentos-${pedido.id}`}
                      aria-label={`${aberto ? 'Ocultar' : 'Ver'} pagamento do pedido ${pedido.numero_pedido}`}
                      onClick={event => { event.stopPropagation(); alternar(pedido.id); }}>
                      <AdminIcon name="chevron" />
                    </button>
                  </td>
                  <td data-label="Nº pedido"><strong>#{pedido.numero_pedido}</strong></td>
                  <td data-label="Cód. cliente">{pedido.codigo_cliente || '-'}</td>
                  <td data-label="Cliente" className="orders-preview-customer">{pedido.nome_cliente}</td>
                  <td data-label="Data e hora">{pedido.data_venda || '-'}</td>
                  <td data-label="Pagamento"><FormasResumo pedido={pedido} /></td>
                  <td data-label="Valor total" className="orders-preview-amount">{moeda.format(pedido.total)}</td>
                </tr>
                {aberto && <tr className="orders-preview-detail" id={`pedido-pagamentos-${pedido.id}`}>
                  <td colSpan={7}><PagamentoDetalhes pedido={pedido} /></td>
                </tr>}
              </React.Fragment>;
            }) : <tr><td colSpan={7}>Nenhum pedido encontrado.</td></tr>}</tbody>
          </table>
        </div>
        <footer className="orders-preview-footer"><span>{pedidos.length} {pedidos.length === 1 ? 'pedido listado' : 'pedidos listados'}</span><button type="button" onClick={onClose}>Fechar</button></footer>
      </section>
    </div>, document.body
  );
}
